import { ImageService, ContentService, ObserverService } from '@DavisDigital/davisdigitalfrontend.module';
import { ContentModuleTypes, EVENTS } from '@DavisDigital/interfaces';

class AddFormModalController {
	
	public contentModule : any;
	public emailAddress : string;
	public images : [];
	public lesson : any;
	public lessonId : string;
	
	public editMode = false; 
	public isLoading = false;

	public portfolioPageId;
	
	public position;
	
	// @ngInject
	constructor(
		public contentService	: ContentService,
		public observerService	: ObserverService,
		public ModalService
	){}
	
	public $onInit = () => {
		if(this.contentModule != null){
			this.emailAddress = this.contentModule.sendToEmailAddress;
		} else {
			this.contentModule = this.contentService.newContentModule( ContentModuleTypes.FORM, this.position);
		}
	}
	
	public save = () =>{
		
		var notifyId = this.lessonId?.length ? this.lessonId : this.portfolioPageId;
		
		this.contentModule.sendToEmailAddress = this.emailAddress;
		this.contentModule.title = 'Contact';
		var eventName = EVENTS.UPDATE_CONTENT ;
		
		if( !this.contentModule.contentModuleID || 
			 this.contentModule.contentModuleID.length !== 32
		){
			eventName = EVENTS.ADD_CONTENT;
		}
		
		this.observerService.notifyById( eventName, notifyId, this.contentModule);
		
		this.close();
	}
	
	public close = () =>{
		this.ModalService.closeModals();
	}

}

class AddFormModal {
	public restrict: string = 'E';
	public scope: boolean = true;
	
	public bindToController: any = {
		type:'=',
		contentModule:'=?',
		lesson:'=?',
		lessonId:'=?',
		portfolioPageId:'=?',
		position:'='
	};

	public controller = AddFormModalController;
	public controllerAs = 'addFormModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/add-form-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { AddFormModal };
